export default "__VITE_ASSET__Cd7m1IBC__"